module.exports = __webpack_public_path__ + "img/jrwmsy.0a02be70.png";